module.exports = __webpack_public_path__ + "static/sec9-shoe-29565b7ad8bb12686a39aac635ba7dad.png";